<script>

export default {
  name: 'SponsorBlock',
  computed: {
    // Mock data -- ideally coming from api request
    sponsor() {
      return {
        logo: 'usa-damage-claims-220.png',
        url: 'http://www.usadamageclaims.com/',
        phone: '888-USA-0872',
        text: 'If Your Property has been damaged or you have a claim and need help. Call USA Damage Claims'
      };
    }
  }
}
</script>

<style>
  .sponsor-text a {
    color: white;
  }
</style>

<template>
  <aside class="sponsor-block widget mt-2">
    <div class="items">
      <div class="sponsor-logo">
        <a :href="sponsor.url" target="_blank"><img :src="require(`@/assets/images/${sponsor.logo}`)" width="100" height="100" alt="Sponsor Logo"></a>
      </div>
      <div class="sponsor-text px-1">
        <p><a :href="sponsor.url" target="_blank">{{ sponsor.text }}</a></p>
        <p>{{ sponsor.phone }}</p>
      </div>
    </div>
  </aside>
</template>